import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppXtender } from '../models/appXtender';


@Injectable({
  providedIn: 'root'
})
export class AppXtenderService {

  public baseUrl: string;
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  getAppList(): Observable<AppXtender[]> {
    return this.http.get<AppXtender[]>(this.baseUrl + 'api/AppXtender');
  }

  save(app: AppXtender) {
    if (app.appId == 0) {
      return this.http.post<AppXtender>(this.baseUrl + 'api/AppXtender',
        app
        ,
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8'
          })
        });
    }
    else {
      return this.http.put<AppXtender>(this.baseUrl + 'api/AppXtender/' + app.appId,
        app
        ,
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json;charset=utf-8'
          })
        });
    }
  }
}
